(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  if (!customElements.get('product-form')) {
    customElements.define('product-form', class extends baseComponent.default {
      elements = {
        form: 'form',
        addButton: '[data-add-button]',
        buyButton: '[data-buy-button]',
        input: '[data-variant-id-input]',
        msgWrapper: '[data-error-msg]',
        msgText: '[data-error-msg-text]'
      };

      error = false;

      async render() {
        this._enableInput();
        this.cartSection = document.querySelector('main-cart');
        this.isProductPage = this.getAttribute('page-type') === 'product';
        if (this.hasAttribute('cart-popup')) {
          this.$form.addEventListener('submit', this._handleSubmit.bind(this));
        }
      };

      _enableInput() {
        this.$input.disabled = false;
      }

      _handleSubmit(e) {
        e.preventDefault();
        this.formData = new FormData(e.target);
        this._addToCartRequest();
      }

      _addToCartRequest() {
        this._setLoading(true);
        if (this.error) {
          this.$msgWrapper.toggleAttribute('hidden', true);
        }
        fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            "Accept": "application/javascript",
            "X-Requested-With":"XMLHttpRequest"
          },
          body: this.formData
        })
        .then(res => res.json())
        .then((res) => {
          if (res.status) {
            this.$msgText.innerText = res.message;
            this.$msgWrapper.toggleAttribute('hidden', false);
            this._setLoading(false);
            this.error = true;
            return;
          }
          this.error = false;
          this.trigger('updateCart', {
            callback: () => {
              this._setLoading(false);
              if (this.cartSection) {
                this.cartSection.update();
              } else {
                this.trigger('openPopup', { target: 'CART' });
              }
            }
          });
        })
        .catch(error => {
          this._setLoading(false);
          console.log(error);
        });
      }

      _setLoading(status) {
        status ? (
          this.$addButton.setAttribute('loading', ''),
          this.$buyButton?.setAttribute('disabled', '')
        ) : (
          this.$addButton.removeAttribute('loading'),
          this.$buyButton?.removeAttribute('disabled')
        );
      }
    });
  }
})();

/* Melisoles Sticky Add to Cart */
const initMeliStickyCart = (root = document) => {
  root.querySelectorAll('[data-meli-sticky-cart]').forEach((stickyCart) => {
    if (stickyCart.dataset.initialized === 'true') return;

    const formId = stickyCart.dataset.productFormId;
    const listener = document.getElementById(`b-${formId}`);
    const stickyButton = stickyCart.querySelector('[data-meli-sticky-add]');
    const stickyPrice = stickyCart.querySelector('.meli-sticky-cart__price');

    if (!listener || !stickyButton) return;

    stickyCart.dataset.initialized = 'true';

    const sectionId = listener.getAttribute('section-id');
    const priceRoot = sectionId ? document.getElementById(`price-${sectionId}`) : null;
    const getCurrentButton = () => listener.querySelector('[data-add-button]');

    const updateStickyPrice = () => {
      if (!stickyPrice || !priceRoot) return;
      const livePrice = priceRoot.querySelector('[data-wpd-variant-price]');
      if (livePrice?.textContent?.trim()) {
        stickyPrice.textContent = livePrice.textContent.trim();
      }
    };

    const updateStickyButton = () => {
      const mainButton = getCurrentButton();
      const unavailable = !mainButton ||
        mainButton.disabled ||
        mainButton.hasAttribute('disabled') ||
        mainButton.hasAttribute('hidden');

      stickyButton.disabled = unavailable;
      stickyButton.textContent = unavailable ? 'SOLD OUT' : 'ADD TO CART';
      updateStickyPrice();
    };

    const observer = new IntersectionObserver(([entry]) => {
      const shouldShow = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      stickyCart.classList.toggle('is-visible', shouldShow);
      stickyCart.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }, { threshold: 0 });

    observer.observe(listener);

    stickyButton.addEventListener('click', () => {
      const mainButton = getCurrentButton();
      updateStickyButton();

      if (mainButton && !mainButton.disabled && !mainButton.hasAttribute('disabled') && !mainButton.hasAttribute('hidden')) {
        mainButton.click();
      }
    });

    const buttonObserver = new MutationObserver(updateStickyButton);
    buttonObserver.observe(listener, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'hidden', 'loading']
    });

    if (priceRoot) {
      const priceObserver = new MutationObserver(updateStickyPrice);
      priceObserver.observe(priceRoot, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    updateStickyButton();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initMeliStickyCart(), { once: true });
} else {
  initMeliStickyCart();
}

document.addEventListener('shopify:section:load', (event) => {
  initMeliStickyCart(event.target);
});
